import { render, staticRenderFns } from "./ReorderForm.vue?vue&type=template&id=107940f6&scoped=true&"
import script from "./ReorderForm.vue?vue&type=script&lang=js&"
export * from "./ReorderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107940f6",
  null
  
)

export default component.exports